// 设计方案
export default [
  {
    path: '/design/dpg',
    name: 'design-dpg',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/dpg/Index.vue'),
    meta: { title: '专案管理' },
  },
  {
    path: '/design/dpg/restore',
    name: 'design-dpg-restore',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/dpg/restore/Restore.vue'),
    meta: { title: '专案管理' },
  },
  {
    path: '/design/dpg/detail/:id',
    name: 'design-dpg-detail',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/dpg/detail/Detail.vue'),
    meta: { title: '专案管理' },
  },
  {
    path: '/design/magazine',
    name: 'design-magazines',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/magazines/Index.vue'),
    meta: { title: '杂志管理' },
  },
  {
    path: '/design/magazine/edit/:id',
    name: 'design-magazines-edit',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/magazines/edit/Edit.vue'),
    meta: { title: '杂志管理' },
  },
  {
    path: '/design/magazine/detail/:id',
    name: 'design-magazines-detail',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/magazines/detail/Detail.vue'),
    meta: { title: '杂志管理' },
  },
  // 预约方
  {
    path: '/design/acceptances',
    name: 'design-acceptances',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/acceptances/Index.vue'),
    meta: { title: '我的设计项目' },
  },
  // 设计方
  {
    path: '/design/appointment',
    name: 'design-appointment',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/appointment/Index.vue'),
    meta: { title: '接受设计项目' },
  },
  // 设计方
  {
    path: '/design/inspections',
    name: 'design-inspections',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/inspections/Index.vue'),
    meta: { title: '设计项目管理' },
  },
  {
    path: '/design/inspections/edit/:id',
    name: 'design-inspections-edit',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/inspections/edit/Edit.vue'),
    meta: { title: '设计项目管理' },
  },
  {
    path: '/design/inspections/detail/:id',
    name: 'design-inspections-detail',
    component: () => import(/* webpackChunkName: "design" */ '@/views/design/inspections/detail/Detail.vue'),
    meta: { title: '设计项目管理' },
  },
];
